export default "__VITE_ASSET__BMwnWYJH__"